<template>
  <div>
    <!-- 头部信息 -->
    <div class="clear"></div>
    <div class="mapbox mt_h">
      <div class="bj_white2 home">
        <div class="country clearfix">
          <img class="fl" :src="addgjflagsrc()" />
          <h2 class="fl">{{countryname}}</h2>
          <h6 class="fr">资料来源：世界银行</h6>
        </div>
        <div class>
          <div class="col-lg-6 w33 characteristics">
            <ul>
              <li>
                <span>国家分组：</span>
                {{countryrange}}
              </li>
              <li>
                <span>收入水平：</span>
                {{countryincome}}
              </li>
            </ul>
          </div>
          <div class="col-lg-6 w33">
            <h2 class="fl">{{newyear}}年营商环境排名:</h2>
            <div class="review fl">
              <span class="icon-container" style="width: 78px;">1</span>
              <div class="progress">
                <span class="percent1" :style="Rankpercentpart">{{CurrentRant}}</span>
                <div class="progress-done1" :data-done="CurrentRant" :style="Rankpercent"></div>
              </div>
              <span class="percent">{{LowestRank}}</span>
            </div>
          </div>
          <div class="col-lg-6 w33">
            <h2 class="fl">{{newyear}}年营商环境得分:</h2>
            <div class="review fl">
              <span class="icon-container" style="width: 78px;">{{MinScore}}</span>
              <div class="progress">
                <span class="percent1" :style="Scorepercentpart">{{Score}}</span>
                <div class="progress-done2" :data-done="Score" :style="Scorepercent"></div>
              </div>

              <span class="percent">{{MaxScore}}</span>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!-- 柱状图 -->
    <div class="home p5 clearfix">
      <div class="w33 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>最近5年营商环境指数得分及全球排名</h1>
          </div>
          <cChart
            id="chart1"
            ref="chart1"
            :option="option1"
            :style="{margin:'0 auto',height:'346px'}"
          ></cChart>
        </div>
      </div>
      <div class="w33 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>营商环境指标分项排名(2020年)</h1>
          </div>
          <c-chart
            v-show="chart2_chart"
            id="chart2"
            ref="chart2"
            :option="option2"
            :style="{margin:'0 auto',height:'346px'}"
          ></c-chart>
          <img
            v-show="chart2_img"
            src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:346px;width: 100%;"
          />
        </div>
      </div>
      <div class="w33 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>营商环境指标分项得分(2020年)</h1>
          </div>
          <c-chart
            id="chart3"
            ref="chart3"
            :option="option3"
            :style="{margin:'0 auto',height:'346px'}"
          ></c-chart>
        </div>
      </div>
    </div>
    <!-- 可选指标柱状图、雷达图 -->
    <div class="home p5">
      <div class="w50 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1>{{chart4title}}营商环境指数得分及排名历年变化</h1>
          </div>
          <div class>
            <div class="fl menu_box" style="height: 438px;width:25%">
              <ul class="menu_box_ul">
                <li>
                  <a @click="icon1" class="icon1 icon1_on_span" title="总体">
                    <span>总体</span>
                  </a>
                </li>
                <li>
                  <a @click="icon2" class="icon2" title="开办企业">
                    <span>开办企业</span>
                  </a>
                </li>
                <li>
                  <a @click="icon3" class="icon3" title="办理施工许可证">
                    <span>办理施工许可证</span>
                  </a>
                </li>
                <li>
                  <a @click="icon4" class="icon4" title="获得电力">
                    <span>获得电力</span>
                  </a>
                </li>
                <li>
                  <a @click="icon5" class="icon5" title="登记财产">
                    <span>登记财产</span>
                  </a>
                </li>
                <li>
                  <a @click="icon6" class="icon6" title="获得信贷">
                    <span>获得信贷</span>
                  </a>
                </li>
                <li>
                  <a @click="icon7" class="icon7" title="保护少数投资者">
                    <span>保护少数投资者</span>
                  </a>
                </li>
                <li>
                  <a @click="icon8" class="icon8" title="纳税">
                    <span>纳税</span>
                  </a>
                </li>
                <li>
                  <a @click="icon9" class="icon9" title="跨境贸易">
                    <span>跨境贸易</span>
                  </a>
                </li>
                <li>
                  <a @click="icon10" class="icon10" title="执行合同">
                    <span>执行合同</span>
                  </a>
                </li>
                <li>
                  <a @click="icon11" class="icon11" title="办理破产">
                    <span>办理破产</span>
                  </a>
                </li>
              </ul>
            </div>
            <div class="fr txbox">
              <div class="fr" style="margin-right: 6%">
                <el-date-picker
                  v-model="chart4date1"
                  type="year"
                  value-format="yyyy"
                  placeholder="开始日期"
                  prefix-icon="elinputiconimg"
                  class="el-input__inner_date"
                  :default-value="timeDefaultShow"
                  :picker-options="pickerOptions_start"
                  @change="datepicker1change"
                ></el-date-picker>&nbsp;&nbsp;-&nbsp;&nbsp;
                <el-date-picker
                  v-model="chart4date2"
                  type="year"
                  value-format="yyyy"
                  placeholder="结束日期"
                  prefix-icon="elinputiconimg"
                  class="el-input__inner_date"
                  :picker-options="pickerOptions_end"
                  @change="datepicker2change"
                ></el-date-picker>
              </div>
              <cChart
                id="chart4"
                ref="chart4"
                :option="option4"
                :style="{height:'378px',margin:'50px 0 0 0 '}"
              ></cChart>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>

      <div class="w50 fl">
        <div class="box1 bj_white2" style="height: 483px;">
          <div class="card_title">
            <h1>{{chart5title}}营商环境分项指标对比</h1>
          </div>
          <div class="fl chart5elselect">
            <el-select
              v-model="chart5countrymodel"
              filterable
              placeholder="选择经济体"
              @change="selectchart5countrys"
            >
              <el-option
                v-for="item in chart5country"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div>
            <cChart
              id="chart5"
              ref="chart5"
              :option="option5"
              :style="{height:'380px',margin:'50px 0 0 0 '}"
            ></cChart>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 信息 -->
    <div class="home">
      <div class="mapbox">
        <div class="bj_white2 home ysbg clearfix">
          <div class="card_title">
            <span>营商报告</span>
            <router-link :to="{ path: '/lit/channel',query:{uid:'800402'}}" class="more">>> 更多</router-link>
          </div>
          <ul class="fl">
            <li class="clearfix" v-for="item in docs1" :key="item.code">
              <a
                class="fl"
                target="_blank"
                :title="item.title"
                :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid='+item.chnid+'&leafid='+item.leafid+'&docid='+item.code.substring(4,item.code.length)+'&uid='+item.uid+'&version=YDYL'"
              >
                <span class="icon_lx">◆</span>
                {{ item.title }}
              </a>
              <span class="fr">{{item.deliveddate.substring(0,10)}}</span>
            </li>
          </ul>
          <ul class="fl">
            <li class="clearfix" v-for="item in docs2" :key="item.code">
              <a
                class="fl"
                target="_blank"
                :title="item.title"
                :href="'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnid='+item.chnid+'&leafid='+item.leafid+'&docid='+item.code.substring(4,item.code.length)+'&uid='+item.uid+'&version=YDYL'"
              >
                <span class="icon_lx">◆</span>
                {{ item.title }}
              </a>
              <span class="fr">{{item.deliveddate.substring(0,10)}}</span>
            </li>
          </ul>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import cChart from "./cgit_chart.vue";
import { api } from "@/require/api";

export default {
  data() {
    return {
      indicatorid: 1,
      countryid: "", //国家id
      countryname: "", //国家名称
      countryrange: "", //地区
      newyear: "", //最新年
      countryincome: "", //收入水平
      CurrentRant: "",
      LowestRank: "",
      Rankpercent: "",
      Rankpercentpart: "",
      Scorepercent: "",
      Scorepercentpart: "",
      MinScore: "",
      Score: "",
      MaxScore: "",
      startTid: "",
      endTid: "",
      docs: [], //营商报告
      docs1: [], //营商报告1-5条
      docs2: [], //营商报告6-10条
      countryBId: "",

      chart4title: "", //图4标题
      timeDefaultShow: "2004",
      pickerOptions_start: {
        disabledDate: time => {
          this.minTime = "2004";
          return time.getTime() < new Date(this.minTime).getTime();
        }
      },
      pickerOptions_end: {
        disabledDate: time => {
          return (
            time.getTime() <
            new Date((parseInt(this.chart4date1) + 1).toString()).getTime()
          );
        }
      },
      chart4date1: "",
      chart4date2: "",
      flag: 0,

      chart5title: "", //图5标题
      chart5country: [],
      chart5countrymodel: "",

      option1: {
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#1D91CE"
            }
          }
        },
        legend: {
          data: ["得分", "排名"],
          x: "left",
          padding: [10, 0, 10, 40]
        },
        xAxis: {
          data: [],
          axisTick: {
            show: false
          }
        },
        yAxis: [
          {
            name: "得分",
            splitLine: {
              show: false
            },
            // scale: true 
          },
          {
            name: "排名",
            splitLine: {
              show: false
            },
            // scale: true 
          }
        ],
        series: [
          {
            name: "得分",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: 8,
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: "#fc5e5e"
              }
            },
            data: []
          },
          {
            name: "排名",
            type: "bar",
            yAxisIndex: 1,
            barWidth: 30,
            itemStyle: {
              normal: {
                barBorderRadius: 2,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#8DC6F5"
                  },
                  {
                    offset: 1,
                    color: "#56ABDF"
                  }
                ])
              }
            },
            data: []
          }
        ]
      },
      option2: {
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: [
          {
            height: "85%",
            left: "20%",
            bottom: "11%"
          },
          {
            height: "85%",
            left: "20%",
            bottom: "11%"
          }
        ],
        xAxis: [
          {
            splitLine: {
              show: false
            }
          },
          {
            gridIndex: 1
          }
        ],
        yAxis: [
          {
            data: [],
            axisLabel: {
              show: true,
              interval: 0,
              rotate: 0
            }
          },
          {
            gridIndex: 1
          }
        ],
        series: [
          {
            name: "",
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "right",
                textStyle: {
                  color: "#000",
                  fontSize: "12"
                }
              }
            },
            itemStyle: {
              normal: {
                color: "#36A5ED"
              }
            },
            barWidth: 25,
            data: []
          }
        ]
      },
      option3: {
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            type: "none"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            itemStyle: {
              normal: {
                color: "#36A5ED"
              }
            },
            name: "",
            type: "bar",
            barWidth: "65%",
            data: []
          }
        ]
      },
      option4: {
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#1D91CE"
            }
          }
        },
        legend: {
          data: ["得分", "排名"],
          x: "left",
          padding: [0, 0, 0, 40]
        },
        xAxis: {
          data: [],
          axisTick: {
            show: false
          },
          axisLabel: {
            rotate: 40
          }
        },
        yAxis: [
          {
            name: "得分",
            splitLine: {
              show: false
            },
            // scale: true 
          },
          {
            name: "排名",
            splitLine: {
              show: false
            },
            // scale: true 
          }
        ],
        series: [
          {
            name: "得分",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: 8,
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: "#fc5e5e"
              }
            },
            data: []
          },
          {
            name: "排名",
            type: "bar",
            yAxisIndex: 1,
            barWidth: 30,
            itemStyle: {
              normal: {
                barBorderRadius: 2,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(31,159,226,0.5)"
                  },
                  {
                    offset: 1,
                    color: "rgba(31,159,226,1)"
                  }
                ])
              }
            },
            data: []
          }
        ]
      },
      option5: {
        color: ["#28ccff", "#ff933b"],
        toolbox: {
          feature: {
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          // formatter:function(parmas){
          //   console.log(parmas);
          // }
          // formatter: '{c}',
        },
        legend: {
          x: "left",
          y: "bottom",
          orient: "vertical",
          icon: "roundRect",
          padding: [0, 0, 30, 40],
          data: []
        },
        radar: {
          axisLabel: {
            show: false,
            showMaxLabel: true, //最大值，即外圈数字
            showMinLabel: true, //最小数字，即中心点0
            textStyle: { fontSize: 10, color: "#999999" }
          },
          axisTick:{
            show:false,
            inside:true,
            length:50,
          },
          name: {
            textStyle: {
              color: "#fff",
              backgroundColor: "#f58866",
              borderRadius: 3,
              padding: [3, 5]
            }
          },
          indicator: [
            { name: "开办企业", max: 100 },
            { name: "办理施工许可证", max: 100 , axisLabel:{show:false}},
            { name: "获得电力", max: 200 , axisLabel:{show:false}},
            { name: "登记财产", max: 200 , axisLabel:{show:false}},
            { name: "获得信贷", max: 200, axisLabel:{show:false}},
            { name: "保护少数投资者", max: 200 , axisLabel:{show:false}},
            { name: "纳税", max: 200, axisLabel:{show:false}},
            { name: "跨境贸易", max: 200 , axisLabel:{show:false}},
            { name: "执行合同", max: 200, axisLabel:{show:false}},
            { name: "办理破产", max: 200 , axisLabel:{show:false}},
          ]
        },
        polar: {},
        angleAxis: {
          show: false,
          axisTick:{
            show:false,
             inside:true,
          },
            // min: 0,
            // max: 360,
            // interval: 30,
            // startAngle: 45
        },
        radiusAxis: {
            min: 0,
            max: 100,
            interval: 20,
            axisTick:{
              show:false,
               inside:true,
            },
             splitLine:{
              show: false
            }
        },
        series: [
          {
            name: "",
            type: "radar",
            symbolSize: 4,
            // label: {
            //   show: true
            // },
            lineStyle: {
              normal: {
                color: "#14A8D6",
                width: 2
              }
            },
            data: []
          },
          {
            name: "",
            type: "radar",
            symbolSize: 4,
            lineStyle: {
              normal: {
                color: "#F07226",
                width: 2
              }
            },
            data: [{value: [500,600,700,800,900],}]
          }
        ]
      },
      chart2_chart: true,
      chart2_img: false
    };
  },
  created() {},
  mounted() {
    this.init();
    // this.timeDefaultShow = new Date('2004');
  },
  methods: {
    init() {
      this.countryid = this.$route.query.countryid;

      this.loadTLPHeaderInfo(); //头部排名得分信息
      this.loadchart5country(); //加载经济体下拉

      this.icon1(); //给第一个指标赋样式并加载数据
      this.addgjflagsrc();
      this.loadchart1();
      this.loadchart2();
      this.loadchart3();
      this.loadchart4();
      this.loadchart5();
      setTimeout(() => {
        this.loaddocument();
      }, 1000);
    },
    //头部排名得分信息
    async loadTLPHeaderInfo() {
      const { code, data } = await api.get(
        "/doingBusinessController/getTLPHeaderInfo",
        {
          countryId: this.countryid
        }
      );
      if (code === 0) {
        this.chart4title = data.CountryName;
        this.countryname = data.CountryName;
        this.countryrange = data.RegionName;
        this.countryincome = data.IncomeLevel;

        this.newyear = data.newyear;
        this.CurrentRant = data.CurrentRant;
        this.LowestRank = data.LowestRank;

        let Rankpercent = (this.CurrentRant / this.LowestRank) * 100;
        if (Rankpercent < 8) {
          Rankpercent = 8;
        }
        this.Rankpercent = "width: " + Rankpercent.toString() + "%";
        this.Rankpercentpart = "left:" + (Rankpercent / 2).toString() + "%";

        this.MinScore = data.MinScore;
        this.Score = data.Score;
        this.MaxScore = data.MaxScore;

        let Scorepercent = (this.Score / this.MaxScore) * 100;
        if (Scorepercent >= 100) {
          Scorepercent = 99;
        }
        this.Scorepercent = "width: " + Scorepercent.toString() + "%";
        this.Scorepercentpart = "left:" + (Scorepercent / 2).toString() + "%";
      }
    },
    //国旗图标
    addgjflagsrc() {
      try {
        let gjimgs = require("../../assets/imgs/flag/" +
          this.countryname +
          ".png");
        return gjimgs;
      } catch (err) {
        let gjerrorimg = require("../../assets/imgs/flag/default.png");
        return gjerrorimg;
      }
    },
    async loadchart1() {
      const { code, data } = await api.get(
        "/doingBusinessController/getRecentFiveInfo",
        {
          countryId: this.countryid
        }
      );
      if (code === 0) {
        this.option1.xAxis.data = data.time;
        this.option1.series[1].data = data.linedata;
        this.option1.series[0].data = data.bardata;
      }
    },
    async loadchart2() {
      const { code, data } = await api.get(
        "/doingBusinessController/getLatestRankAndScore",
        {
          countryId: this.countryid
        }
      );
      if (code === 0) {
        if ((data.rankingdata.length) > 0 && (data.ranking.length > 0)) {
          this.option2.series[0].data = data.rankingdata;
          this.option2.yAxis[0].data = data.ranking;
          this.chart2_chart = true
          this.chart2_img = false
        }else{
          this.option2.series[0].data = []
          this.option2.yAxis[0].data = []
          this.chart2_chart = false
          this.chart2_img = true
        }
        
      }
    },
    async loadchart3() {
      const { code, data } = await api.get(
        "/doingBusinessController/getLatestRankAndScore",
        {
          countryId: this.countryid
        }
      );
      if (code === 0) {
        this.option3.xAxis[0].data = data.score;
        this.option3.series[0].data = data.scoredata;
      }
    },
    datepicker1change(value) {
      this.flag = 1;
      this.chart4date1 = value;
      if (this.chart4date2 == "") {
        {
          this.$message({
            message: "请选择结束时间",
            type: "warning"
          });
        }
      }
      this.loadchart4();
    },
    datepicker2change(value) {
      this.flag = 1;
      this.chart4date2 = value;
      if (this.chart4date1 == "") {
        {
          this.$message({
            message: "请选择开始日期",
            type: "warning"
          });
        }
      }
      this.loadchart4();
    },
    async loadchart4() {
      const { code, data } = await api.get(
        "/doingBusinessController/getSelectiveRankAndScore",
        {
          countryId: this.countryid,
          indicatorId: this.indicatorid,
          startTid: this.chart4date1,
          endTid: this.chart4date2,
          flag: this.flag
        }
      );
      if (code === 0) {
        this.option4.xAxis.data = data.time;
        this.option4.series[0].data = data.linedata;
        this.option4.series[1].data = data.bardata;
      }
    },
    //图5经济体下拉
    async loadchart5country() {
      const { code, data } = await api.get(
        "/doingBusinessController/getTimesAndCountrys"
      );
      if (code === 0) {
        if (data.countryNames[0].name == "全部经济体")
          //因为接口中有"全部经济体"，因此需要去掉
          data.countryNames.splice(0, 1);
        this.chart5country = data.countryNames; //下拉值
      }
    },
    selectchart5countrys(value) {
      this.countryBId = value;
      this.loadchart5();
    },
    //图5
    async loadchart5() {
      if (this.countryBId == ""){
        this.countryBId = this.countryid; //还未选对比经济体时，给个值
        // this.chart5title = data[0].name + "与" + data[1].name;
      } 
      const { code, data, max } = await api.get(
        "/doingBusinessController/getRadarData",
        {
          countryAId: this.countryid,
          countryBId: this.countryBId
        }
      );
      if (code === 0) {
        let chart5legend = [];
        chart5legend.push(data[0].name); //chart5-legend第一个国家

        for (let indicatornum = 0; indicatornum < 10; indicatornum++) {//设置雷达图刻度的最大值
          this.option5.radar.indicator[indicatornum].max = max;
        }

        if (data[1].name != null) {
          this.chart5title = data[0].name + "与" + data[1].name;
          //选择了第二个国家
          chart5legend.push(data[1].name);

          this.option5.series[1].name = data[1].name;
          this.option5.series[1].data = []; //因为会重复加，所以清一下
          this.option5.series[1].data.push({value: data[1].value});
        }
        this.option5.legend.data = chart5legend;

        this.option5.series[0].name = data[0].name;
        this.option5.series[0].data = [];
        this.option5.series[0].data.push({value: data[0].value}); 
      }
    },
    //营商报告
    async loaddocument() {
      const { code, data } = await api.get(
        "/documentController/getPageChannelDocumentsByUId",
        {
          curPage: 1,
          pageSize: 10,
          uid: "800402",
          attr: this.countryname
        }
      );
      if (code === 0) {
        this.docs = data.data;
        this.docs1 = this.docs.slice(0, 5);
        this.docs2 = this.docs.slice(5, 10);
      }
    },
    //icon赋不同样式
    icon1() {
      this.indicatorid = 1;
      $(".icon1").addClass("icon1_on");
      $(".icon1").children().addClass("icon1_on_span");
      this.icon0(1);
    },
    icon2() {
      this.indicatorid = 2;
      $(".icon2").addClass("icon2_on");
      $(".icon2").children().addClass("icon2_on_span");
      this.icon0(2);
    },
    icon3() {
      this.indicatorid = 3;
      $(".icon3").addClass("icon3_on");
      $(".icon3").children().addClass("icon3_on_span");
      this.icon0(3);
    },
    icon4() {
      this.indicatorid = 4;
      $(".icon4").addClass("icon4_on");
      $(".icon4").children().addClass("icon4_on_span");
      this.icon0(4);
    },
    icon5() {
      this.indicatorid = 5;
      $(".icon5").addClass("icon5_on");
      $(".icon5").children().addClass("icon5_on_span");
      this.icon0(5);
    },
    icon6() {
      this.indicatorid = 6;
      $(".icon6").addClass("icon6_on");
      $(".icon6").children().addClass("icon6_on_span");
      this.icon0(6);
    },
    icon7() {
      this.indicatorid = 7;
      $(".icon7").addClass("icon7_on");
      $(".icon7").children().addClass("icon7_on_span");
      this.icon0(7);
    },
    icon8() {
      this.indicatorid = 8;
      $(".icon8").addClass("icon8_on");
      $(".icon8").children().addClass("icon8_on_span");
      this.icon0(8);
    },
    icon9() {
      this.indicatorid = 9;
      $(".icon9").addClass("icon9_on");
      $(".icon9").children().addClass("icon9_on_span");
      this.icon0(9);
    },
    icon10() {
      this.indicatorid = 10;
      $(".icon10").addClass("icon10_on");
      $(".icon10").children().addClass("icon10_on_span");
      this.icon0(10);
    },
    icon11() {
      this.indicatorid = 11;
      $(".icon11").addClass("icon11_on");
      $(".icon11").children().addClass("icon11_on_span");
      this.icon0(11);
    },
    //除当时icon，移除其它on样式
    icon0(num) {
      for (let i = 1; i <= 11; i++) {
        if (num != i) {
          $(".icon" + i).removeClass("icon" + i + "_on");
          $(".icon" + i).children().removeClass("icon" + i + "_on_span");
        }
      }
      this.loadchart4(); //图4
    }
  },
  components: {
    cChart
  },
  watch: {
    $route: function() {
      this.init();
    }
  }
};
</script>

<style lang='less' scoped>
.clear {
  clear: both;
}
// 营商头部基本信息
.country {
  padding: 25px;
}
.country img {
  float: left;
}
.country h2 {
  float: left;
  font-size: 18x;
  line-height: 25px;
  padding-left: 10px;
}
.characteristics ul li {
  float: left;
  padding-left: 5px;
  padding-right: 20px;
  padding-top: 10px;
}
.characteristics ul li span {
  font-weight: bold;
}
.mapbox {
  padding: 5px 10px;
  box-sizing: border-box;
  .ysbg {
    ul {
      width: 50%;
      padding: 25px;
      li {
        line-height: 35px;
        a {
          color: #333;
          width: 80%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          text-align: left;
          .icon_lx {
            padding-right: 5px;
          }
        }
        span {
          color: #666;
        }
      }
    }
  }
}
.mt_h {
  margin-top: 6px;
}
.w33 {
  width: 33.33%;
  padding: 0 5px;
  position: relative;
}
.col-lg-6 {
  float: left;
  border-left: 1px solid #d7dfe3;
  border-top: 1px solid #d7dfe3;
  padding: 20px 20px 30px 20px;
}
.col-lg-6 h2 {
  font-size: 15px;
  font-weight: bold; /*! line-height: 34px; */
  margin-top: 9px;
  margin-left: 20px;
}
.review {
  border: 1px solid transparent;
  border-radius: 5px;
  color: #777;
  display: flex;
  font-size: 12px;
  align-items: center;
  margin: 0px 10px;
  width: 57.5%;
  margin-top: 9px;
}
.progress {
  background-color: rgba(100, 100, 100, 0.2);
  border-radius: 100px;
  position: relative;
  margin: 0 5px;
  height: 20px;
  width: 90%;
}
.progress-done1 {
  background: linear-gradient(to left, rgb(103, 194, 58), rgb(166, 213, 83));
  border-radius: 100px;
  height: 20px;
  transition: width 1s ease 0.3s;
}
.progress-done2 {
  background: linear-gradient(to left, rgb(242, 97, 90), rgb(255, 148, 114));
  border-radius: 100px;
  height: 20px;
  transition: width 1s ease 0.3s;
}
.percent {
  color: #333;
  white-space: nowrap;
  z-index: 999;
}
.percent1 {
  position: absolute;
  left: 0px;
  display: inline-block;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
}

// 柱状图
.card_title {
  position: relative;
  background: url(../../assets/imgs/titlebj.png) repeat-x top;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #d7dfe3;
  border-left: 1px solid #d7dfe3;
  margin-left: -1px;
}
.card_title .more,.card_title h1,.card_title span {
  text-align: center;
  line-height: 45px;
  font-weight: 600;
  font-size: 0.95vw;
  font-size: 15px;
}
.card_title .more{
  position: absolute;
  top: 0px;
  right: 30px;
  color: #202223;
  // margin-left: 100px;
}
.card_title .more:hover{
  color:#1260af;
}
.w50 {
  width: 50%;
  padding: 0 5px;
  position: relative;
}
.menu_box_ul {
  background: #f4f7fa;
  border: 1px solid #d4dfea;
  border-radius: 20px;
  width: 100%;
  // padding: 15px;
  padding-left: 0;
  margin: 20px 0px 0px 12px;
  position: relative;
}
.menu_box_ul li {
  line-height: 35px;
  padding-right:5px;
}
.menu_box_ul li a {
  display: block;
  height: 34px;
  font-size: 13px;
  line-height: 34px;
  color: #30363c;
  text-align: left;
}
.txbox {
  width: 74%;
}

//可选指标柱状图
.c-datepicker-date-editor {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid#dcdfe6;
  box-sizing: border-box;
  color: #333;
  display: inline-block;
  font-size: inherit;
  height: 34px;
  line-height: 34px;
  outline: none;
  padding: 0 15px;
  white-space: nowrap;
  margin-top: 15px;
  margin-left: 20px;
  margin-right: 20px;
}
.c-datepicker-range__icon {
  display: inline-block;
  text-align: center;
}
/deep/.elinputiconimg {
  background: url(../../assets/imgs/time.png) no-repeat;
  height: 16px;
  display: inline-block;
  width: 16px;
  margin-top: 8px;
}

.c-datepicker-data-input.only-date {
  width: 86px;
}
.c-datepicker-data-input {
  border: none;
  outline: none;
  display: inline-block;
  height: 100%;
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 14px;
  color: #333;
  line-height: 1;
  vertical-align: top;
  background-color: #fff;
}
.c-datepicker-range-separator {
  padding: 0 3px;
  display: inline-block;
  text-align: center;
}
.datepickerwidth {
  width: 250px;
  margin-top: 15px;
}
/deep/.el-input__inner_date {
  width: 110px;
  margin-top: 10px;
  input {
    height: 34px;
    font-size: 12px;
  }
}

.icon1 {
  background: url(../../assets/imgs/icon1_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon1:hover {
  background: url(../../assets/imgs/icon1_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon1_on {
  background: url(../../assets/imgs/icon1_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon1:hover span{
  color: #f6231b;
  font-weight: 700;
}
.icon1_on_span{
  color: #f6231b;
  font-weight: 700;
}

.icon2 {
  background: url(../../assets/imgs/icon2_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon2:hover {
  background: url(../../assets/imgs/icon2_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon2_on {
  background: url(../../assets/imgs/icon2_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon2:hover span{
  color: #3bd5a1;
  font-weight: 700;
}
.icon2_on_span{
  color: #3bd5a1;
  font-weight: 700;
}


.icon3 {
  background: url(../../assets/imgs/icon3_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon3:hover {
  background: url(../../assets/imgs/icon3_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon3_on {
  background: url(../../assets/imgs/icon3_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon3:hover span{
  color: #9954ac;
  font-weight: 700;
}
.icon3_on_span{
  color: #9954ac;
  font-weight: 700;
}

.icon4 {
  background: url(../../assets/imgs/icon4_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon4:hover {
  background: url(../../assets/imgs/icon4_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon4_on {
  background: url(../../assets/imgs/icon4_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon4:hover span{
  color: #2bcaf4;
  font-weight: 700;
}
.icon4_on_span{
  color: #2bcaf4;
  font-weight: 700;
}

.icon5 {
  background: url(../../assets/imgs/icon5_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon5:hover {
  background: url(../../assets/imgs/icon5_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon5_on {
  background: url(../../assets/imgs/icon5_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon5:hover span{
  color: #fd924b;
  font-weight: 700;
}
.icon5_on_span{
  color: #fd924b;
  font-weight: 700;
}

.icon6 {
  background: url(../../assets/imgs/icon6_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon6:hover {
  background: url(../../assets/imgs/icon6_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon6_on {
  background: url(../../assets/imgs/icon6_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon6:hover span{
  color: #6a75f5;
  font-weight: 700;
}
.icon6_on_span{
  color: #6a75f5;
  font-weight: 700;
}

.icon7 {
  background: url(../../assets/imgs/icon7_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon7:hover {
  background: url(../../assets/imgs/icon7_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon7_on {
  background: url(../../assets/imgs/icon7_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon7:hover span{
  color: #5cd46c;
  font-weight: 700;
}
.icon7_on_span{
  color: #5cd46c;
  font-weight: 700;
}

.icon8 {
  background: url(../../assets/imgs/icon8_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon8:hover {
  background: url(../../assets/imgs/icon8_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon8_on {
  background: url(../../assets/imgs/icon8_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon8:hover span{
  color: #c79706;
  font-weight: 700;
}
.icon8_on_span{
  color: #c79706;
  font-weight: 700;
}

.icon9 {
  background: url(../../assets/imgs/icon9_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon9:hover {
  background: url(../../assets/imgs/icon9_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon9_on {
  background: url(../../assets/imgs/icon9_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;

}
.icon9:hover span{
  color: #71b5fe;
  font-weight: 700;
}

.icon9_on_span{
  color: #71b5fe;
  font-weight: 700;
}

.icon10 {
  background: url(../../assets/imgs/icon10_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon10:hover {
  background: url(../../assets/imgs/icon10_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon10_on {
  background: url(../../assets/imgs/icon10_h.png) no-repeat 10px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon10:hover span{
  color: #fd91a3;
  font-weight: 700;
}
.icon10_on_span{
  color: #fd91a3;
  font-weight: 700;
}

.icon11 {
  background: url(../../assets/imgs/icon11_ys.png) no-repeat 10px 7px;
  height: 24px;
  padding-left: 32px;
}
.icon11:hover {
  background: url(../../assets/imgs/icon11_h.png) no-repeat 11px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon11_on {
  background: url(../../assets/imgs/icon11_h.png) no-repeat 11px 7px;
  height: 34px;
  padding-left: 32px;
  cursor: pointer;
}
.icon11:hover span{
  color: #2bcaf4;
  font-weight: 700;
}
.icon11_on_span{
  color: #2bcaf4;
  font-weight: 700;
}

//雷达图
.k-dropdown-wrap {
  width: 210px;
}
.k-state-default {
  position: absolute;
  height: 40px;
  line-height: 38px;
  border: 0px;
  border-radius: 0px;
  text-align: left;
  background-color: #1583cc;
  color: #ffffff;
  -webkit-box-shadow: none;
  box-shadow: none;
  float: left;
  background-image: none;
  margin-top: 7px;
  margin-left: 10px;
}
.k-input {
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  padding-left: 20px;
  position: relative;
  top: 6px;
}
.k-select {
  width: 2.6em;
}
.k-select {
  position: absolute;
  top: 11px;
  right: 0;
  display: inline-block;
}

.k-icon {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 1em;
  height: 1em;
  text-align: center;
  vertical-align: middle;
  background: url(../../assets/imgs/drop-down1.png) no-repeat center;
  font: 16px/1 WebComponentsIcons;
  font-variant-caps: normal;
  font-weight: normal;
  font-family: WebComponentsIcons;
  font-variant-alternates: normal;
  font-variant-east-asian: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-position: normal;
  speak: none;
  font-variant: normal;
  text-transform: none;
  text-indent: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
}
.ld_jjt {
  background: #f4f7fa !important;
  border: 1px solid#d4dfea;
  border-radius: 100px;
}
.black {
  color: #30363c !important;
}
.k-icon2 {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 1em;
  height: 1em;
  text-align: center;
  vertical-align: middle;
  background: url(../../assets/imgs/drop-down2.png) no-repeat center;
  font: 16px/1 WebComponentsIcons;
  font-variant-caps: normal;
  font-weight: normal;
  font-family: WebComponentsIcons;
  font-variant-alternates: normal;
  font-variant-east-asian: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-position: normal;
  speak: none;
  font-variant: normal;
  text-transform: none;
  text-indent: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: inherit;
}
/deep/.chart5elselect {
  margin: 10px 0 0 10px;
  input {
    background: #f4f7fa !important;
    border: 1px solid#d4dfea;
    border-radius: 100px;
  }
}

//营商报告
.ysbg ul {
  width: 50%;
  float: left;
  padding: 25px;
}
.ysbg ul li {
  line-height: 35px;
}
.ysbg ul li span {
  color: #666;
}
.icon_lx {
  padding-right: 5px;
}
</style>